function s(n,r){let o=r.split("."),e=n;for(let t of o)if(e&&typeof e=="object"&&t in e)e=e[t];else return;return e}export{s as a};
